const MSAP_WITH_VARIATOR = 'Installation moteur MSAP + variateur';
const IE4_WITH_VARIATOR = 'Installation moteur IE4 + variateur';
const IE3_WITH_VARIATOR = 'Installation moteur IE3 + variateur';
const IE2_WITH_VARIATOR = 'Installation moteur IE2 + variateur';
const CURRENT_WITH_VARIATOR = "Ajout d'un variateur au moteur actuel";
const IE4_NO_VARIATOR = 'Installation moteur IE4';
const IE3_NO_VARIATOR = 'Installation moteur IE3';

export {
    MSAP_WITH_VARIATOR,
    IE4_WITH_VARIATOR,
    IE3_WITH_VARIATOR,
    IE2_WITH_VARIATOR,
    CURRENT_WITH_VARIATOR,
    IE4_NO_VARIATOR,
    IE3_NO_VARIATOR,
}


// WEBPACK FOOTER //
// ./src/components/partials/EnergeticGains/constants.js